import { DocViewerRenderers } from '@cyntler/react-doc-viewer';

const unsafeTextFileTypes = new Set(['txt', 'text/plain']);

// The package's TXT renderer renders untrusted file contents without sanitizing them.
export const safeDocViewerRenderers = DocViewerRenderers.filter(
  renderer => !renderer.fileTypes?.some((fileType: string) => unsafeTextFileTypes.has(fileType)),
);
